<template>
 <v-app>  
   <v-container >
    <v-toolbar flat color="white">
      <v-toolbar-title>{{ this.$route.params.name }}</v-toolbar-title>
     
      <v-spacer></v-spacer>
     <v-btn
     @click="csvOBJ"
      color="primary">
     Download CSV
    </v-btn>
      <v-btn @click='addDialog = true' color="green" dark class="mb-2" >Add to Location</v-btn>
        <v-btn @click='deleteDialog = true' color="red" dark class="mb-2" >Delete Location</v-btn>
    </v-toolbar>
    <v-data-table
      v-model="selected"
      select-all
      :headers="headers"
      item-key="Discovery.asset"
      :items="assetDetail"
      class="elevation-1"
    >
     <template slot="headers" slot-scope="props">
      <tr>

        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
          @click="changeSort(header.value)"
        >
          <v-icon small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
      <template v-slot:items="props">

      <td class="text-xs-right">{{ props.item.Discovery.AssetTag }}</td>
      <td class="text-xs-right">{{ props.item.Discovery.CpuTitle }}</td>
      <td class="text-xs-right">{{ props.item.Discovery.RamTitle }}</td>
      <td class="text-xs-right">{{ props.item.Discovery.HddTitle }}</td>
      <td class="text-xs-right">{{ props.item.Discovery.SystemInfo.Make }}</td>
      <td class="text-xs-right">{{ props.item.Discovery.SystemInfo.Model }}</td>
     <td class="text-xs-right">{{ props.item.Discovery.SystemInfo.Serial }}</td>
      <td class="text-xs-right">{{ props.item.Discovery.Sku }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            @click.stop="removeAssetFromLocationDialog = true,selectedAsset = props.item"
          >
            delete
          </v-icon>
        </td>
       
      </template>
    </v-data-table>
  <v-dialog
      v-model="addDialog"
      width="600"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add to Location
        </v-card-title>

          <v-layout>
             <v-flex xs6 md6>
        <v-textarea
        required
          outline
          name="input-7-4"
          label="Scan Asset Tags Here"
          v-model="assetsUI"
          @blur="validate()"
        ></v-textarea>
      </v-flex>
      <v-flex xs6 md6>
         <p v-for='(message,index) in messages' v-bind:key='index'  class="red--text">{{message}}</p>
        </v-flex>
          </v-layout>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            color="primary"
            flat
            @click="addToLocation(),dialog = false"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card > 
        <v-card-title style='color:red'  class="headline grey lighten-2">Remove Location</v-card-title>
        <v-card-text>
            Are you sure you want to delete location: {{this.$route.params.name}}     
       </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            flat="flat"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            flat="flat"
            @click="deleteDialog = false; deleteLocation()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<v-dialog
      v-model="removeAssetFromLocationDialog"
      max-width="290"
    >
      <v-card v-if='selectedAsset'> 
        <v-card-title  style='color:red' class="headline">Edit</v-card-title>
        <v-card-text >
         Are you sure you want to disassociate {{selectedAsset.Discovery.AssetTag}} from location: {{$route.params.name}}
       </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            flat="flat"
            @click="removeAssetFromLocationDialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            flat="flat"
            @click="removeAssetFromLocationDialog = false; removeAssetLocation()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   </v-container>

</v-app>

</template>



<script>
const fb = require('../firebaseConfig.js')
const { Parser } = require('json2csv')
const _ = require("lodash")
export default{
  props : {
    Location : {
    name : String,
    status : String,
    desc : String,
    assets : Array
    }
  },
data() {
return {
  valid: false,
  assetsUI : null,
  messages : [],
  LocationIDs : [],
  assetstoAdd : [],
  selectedAsset : null,
  addDialog : false,
  removeAssetFromLocationDialog:false,
  deleteDialog : false,
  pagination: {
        sortBy: 'asset'
      },
  selected: [],
    headers: [
         { text: 'Asset', value: 'asset' },
          { text: 'CPU', value: 'cpu' },
         { text: 'RAM', value: 'ram' },
          { text: 'HDD', value: 'hdd' },
          { text: 'Make', value: 'make' },
           { text: 'Model', value: 'model' },
             { text: 'Serial', value: 'serial' },
              { text: 'SKU', value: 'sku' },
          { text: 'Actions', value:'' ,sortable: false }
        ],
    assetDetail : []
      }


} ,
methods: {
    csvOBJ(){
      var json = this.assetDetail.map(x => x)
      let host = window.location.hostname === "localhost" ? "https://techspec.app" : window.location.hostname
      json.map(item => {return item.AssetURL = host + "/public/assets/" + item.Discovery.AssetTag});
      
      json.map(item=>{return ('GraphCardsInfo' in item.Discovery && item.Discovery.GraphCardsInfo.length > 0) ? item.Discovery.GraphCardsInfo[0].GraphicCardName : item.Discovery.GraphCardsInfo = [{GraphicCardName : "" }]})
      const fields = [
      {label : "Asset Tag", value :"Discovery.AssetTag"},
      {label : "Asset URL", value :"AssetURL"},
      {label : "Serial", value :"Discovery.SystemInfo.Serial"},
      {label : "SKU", value :"Discovery.sku"},
      {label : "Form Factor Type", value :"mischardwarespec.computerType"},
      {label : "Condition Description", value :"mischardwarespec.conditionDesc"},
      {label : "Make", value :"Discovery.SystemInfo.Make"},
      {label : "Model", value :"Discovery.SystemInfo.Model"},
      {label : "CPU", value :"Discovery.CpuTitle"},
      {label : "Hard Drive", value :"Discovery.HddTitle"},
      {label : "Storage Type", value :"mischardwarespec.storageType"},
      {label : "Memory", value :"Discovery.RamTitle"},
      {label : "Video Card", value : 'Discovery.GraphCardsInfo[0].GraphicCardName'},
      {label : "Screen Size", value :"mischardwarespec.screensize"},
      {label : "Color", value :"mischardwarespec.color"},
      {label : "Display Port", value :"mischardwarespec.displayPort"},
      {label : "Gigabit Ethernet", value :"mischardwarespec.ethernet"},
      {label : "Mini Display Port", value :"mischardwarespec.minidisplayport"},
      {label : "HDMI", value :"mischardwarespec.hdmi"},
      {label : "Micro-HDMI", value :"mischardwarespec.microHDMI"},
      {label : "Mico-USB", value :"mischardwarespec.microUSB"},
      {label : "Mini-Gigabit Ethernet", value :"mischardwarespec.miniEthernet"},
      {label : "Mini-USB", value :"mischardwarespec.miniUSB"},
      {label : "USB 1", value :"mischardwarespec.usb1"},
      {label : "USB 2", value :"mischardwarespec.usb2"},
      {label : "10/100 Card", value :"mischardwarespec.lanCard"},
      {label : "3d Camera", value :"mischardwarespec.camera3d"},
      {label : "Backlist Keyboard", value :"mischardwarespec.backLitKeyboard"},
      {label : "Bluetooth", value :"mischardwarespec.bluetooth"},
      {label : "Webcam", value :"mischardwarespec.webcam"},
      {label : "HSDPA", value :"mischardwarespec.hsdpa"},
      {label : "Rugged", value :"mischardwarespec.rugged"},
      {label : "Tablet", value :"mischardwarespec.tabletPC"},
      {label : "Touchscreen", value :"mischardwarespec.touchScreen"},
      ];
      const json2csvParser = new Parser({ fields });
      const csv = json2csvParser.parse(json);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += csv
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
      return json
    },
  addToLocation(){
    var idOnly = this.assetDetail.map(item => item.Discovery.AssetTag);
    //marge both array (user provodied and db array, remove any duplicate)
    var combinedArray = idOnly.concat(this.assetstoAdd)
    combinedArray = combinedArray.filter(function (item, pos) {return combinedArray.indexOf(item) == pos})
    //update the document
    fb.LocationsCollections.doc(this.$route.params.name).update({
                  "assets" : combinedArray
})    
    //update the location prop for the new assets added to the location
    this.assetstoAdd.forEach( (item) => {
           fb.AssetsCollections.doc(item).update({
                  "Discovery.Location" : this.$route.params.name
})  
});
    this.addDialog = false
  },
  validate(){
      if (this.assetsUI !== null){
        this.assetsUI.endsWith("\n") ? this.assetsUI : this.assetsUI = this.assetsUI + "\n"
         this.assetstoAdd = this.assetsUI.split("\n")
         //remove white space
         this.assetstoAdd = this.assetstoAdd.filter(function(e){return e})
         //remove duplicate
         this.assetstoAdd = this.assetstoAdd.filter((item, index) => this.assetstoAdd.indexOf(item) === index)
        for(var i = 0; i< this.assetstoAdd.length; i++){
          this.messages=[]
          let currentA = this.assetstoAdd[i]
        fb.AssetsCollections.doc(this.assetstoAdd[i]).get().then((doc)=> {
          if (!doc.exists) {
            this.valid = false
            this.messages.push('Failed to Locate Asset '+ currentA + ' in Database');
        }
        else{
              if('Location' in doc.data().Discovery === false){
                return this.valid = true
              }
        if(doc.data().Discovery.Location !== null){
            this.valid = false
            this.messages.push('Asset '+ currentA + ' is assigned to Location: ' + doc.data().Discovery.Location);
          }
          else{
            this.valid = true
          }
        }
    })
        }
      }

    },
  removeAssetLocation(){
    this.locationIDs = this.locationIDs.filter((item)=> { 
    return item !== this.selectedAsset.Discovery.AssetTag
})
       fb.AssetsCollections.doc(this.selectedAsset.Discovery.AssetTag).update({
                  "Discovery.Location" : null
})     
      fb.LocationsCollections.doc(this.$route.params.name).update({
        "assets" : this.locationIDs
      })
  },
  toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.assetDetail.slice()
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      deleteItem(item){
        fb.AssetsCollections.doc(item.name).remove()
      },
      deleteLocation(){
      fb.AssetsCollections.where("Discovery.Location", "==", this.$route.params.name).get().then(function(querySnapshot) {
    querySnapshot.forEach(function(doc) {
       fb.AssetsCollections.doc(doc.id).update({
                  "Discovery.Location" : null
})
    })
   })
      
      fb.LocationsCollections.doc(this.$route.params.name).delete()
      this.$router.push({ name: 'Location' })
    },
},
 mounted(){
   
   fb.AssetsCollections.where("Discovery.Location", "==", this.$route.params.name ).onSnapshot((querySnapshot) => {
     this.assetDetail = []
     this.locationIDs = []
        querySnapshot.forEach((doc) => {  
            this.locationIDs.push(doc.data().Discovery.AssetTag)
            this.assetDetail.push(doc.data())
        })
    })

  } 
}


</script>